const checkPluralWording = (word) => {
  if (word.slice(-1) === 'y') {
    return `${word.slice(0, word.length - 1)}ies`;
  }

  return `${word}s`;
};

export default (word, count) => `${count} ${parseInt(count, 10) === 1 ? word : checkPluralWording(word)}`;
